import React, { useEffect, useState } from 'react';
import './Skills.css';
import Skillset from './skillData';

const Skills = () => {
  const [skillData, setSkillData] = useState(Skillset);
  const [activeClass, setActiveClass] = useState('');
  const hangleFilterSkills = (type) => {
    if (type === '') {
      setSkillData(Skillset);
    } else {
      const filterSkills = Skillset.filter(skills => skills.type === type);
      setSkillData(filterSkills);
    }
    setActiveClass(type);
  }

  return (
    <section className="skills" id="about">
      <div className="max-width">
        <h2 className="title">My skills</h2>
        <div className="skills-content">
          <div className="category">
            <ul>
              <li className={activeClass === 'Frontend' ? 'active' : ''} onClick={() => hangleFilterSkills('Frontend')}>Frontend</li>
              <li className={activeClass === 'Backend' ? 'active' : ''} onClick={() => hangleFilterSkills('Backend')}>Backend</li>
              <li className={activeClass === '' ? 'active' : ''} onClick={() => hangleFilterSkills('')}>All</li>
              <li className={activeClass === 'Programming' ? 'active' : ''} onClick={() => hangleFilterSkills('Programming')}>Programming</li>
              <li className={activeClass === 'Tools' ? 'active' : ''} onClick={() => hangleFilterSkills('Tools')}>Tools</li>
            </ul>
          </div>
          <div className="skillset">
            {
              skillData.map(skill => <div className="skill-list" key={skill.id} data-aos="fade-up" data-aos-duration="1000">
                <img src={require(`./logos/${skill.img}`)} alt="img" />
                <span>{skill.name}</span>
              </div>)
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;